function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//Lib Imports
import React, { useState, useCallback, useEffect } from 'react';
import { Box, Text, Layer } from 'grommet';
import { Close, Next } from 'grommet-icons';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { sha512crypt } from 'sha512crypt-node';

//Core Imports
import { useToast } from 'granite-admin/core/components/Toast';

//App Imports
import Loader from 'granite-admin/core/components/Loader';
import Divider from 'granite-admin/core/components/Divider';
import Copy from 'granite-admin/core/components/Copy';
import iframeApi from 'granite-admin/common/gateways/iframe-api';
const domainUrl = process.env.REACT_APP_DOMAIN_URL;
const projectName = process.env.REACT_APP_PROJECT_NAME || 'Granite';
const APIbaseUrl = process.env.REACT_APP_ANGLE42_BASE_URL || process.env.REACT_APP_ORGANISATION_BASE_URL;
const Accord = ({
  active,
  setActive,
  index,
  title,
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(Box, _extends({
  direction: "row"
}, rest), /*#__PURE__*/React.createElement(Box, {
  direction: "row",
  width: "25%",
  background: active === index ? 'brand' : 'light-4',
  pad: {
    horizontal: 'medium',
    vertical: 'medium'
  },
  gap: "small",
  round: {
    size: 'xsmall',
    corner: active === index ? 'left' : null
  },
  onClick: () => active === index ? setActive(null) : setActive(index)
}, /*#__PURE__*/React.createElement(Next, {
  size: "16px",
  color: active === index ? 'white' : null
}), /*#__PURE__*/React.createElement(Box, {
  gap: "small"
}, /*#__PURE__*/React.createElement(Text, {
  size: "16px"
}, title))), active === index && /*#__PURE__*/React.createElement(Box, {
  width: "75%",
  elevation: "small",
  pad: "medium",
  gap: "medium"
}, children));
const ViewUrlLayer = ({
  closeLayer,
  layer
}) => {
  const {
    pathname
  } = useLocation();
  const {
    errorToast
  } = useToast();
  const [url, setUrl] = useState('');
  const [loader, setLoader] = useState(true);
  const [active, setActive] = useState(null);
  const [payload, setPayload] = useState(null);
  const hashScript = `var sha512crypt = require('sha512crypt-node').sha512crypt;
var userHash = sha512crypt(email, orgId);`;
  const getOrgId = useCallback(async () => {
    try {
      let orgId = await iframeApi.getOrgId(APIbaseUrl);
      let userHash = sha512crypt(layer, orgId);
      setPayload({
        orgId,
        email: layer,
        userHash
      });
      setLoader(false);
      setUrl(`<script>
  var container="app",
      orgId=${orgId},
      email=${layer},
      userHash=${userHash};
  var div=document.getElementById(container);
  var ifrm=document.createElement("iframe");
  ifrm.setAttribute("src","${domainUrl}${pathname.substring(1)}/
        ?oAuthToken="AUTH-TOKEN-WILL-GO-HERE"
        &orgId="ORGANIZATION-ID-TOKEN-WILL-GO-HERE"
        &route=${pathname}
        &embed=true"
      );
  ifrm.style.flexGrow="1";
  ifrm.setAttribute( "frameBorder","0");
  div.appendChild(ifrm);
</script>`);
    } catch {
      errorToast('Unable to get org id');
      closeLayer();
    }
  }, [layer, pathname, errorToast]);
  useEffect(() => {
    getOrgId();
  }, [getOrgId]);
  return /*#__PURE__*/React.createElement(Layer, {
    full: "vertical",
    position: "right",
    onClickOutside: closeLayer,
    onEsc: closeLayer
  }, loader ? /*#__PURE__*/React.createElement(Box, {
    width: "1100px",
    fill: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: true,
    align: "center",
    justify: "center",
    pad: "large"
  }, /*#__PURE__*/React.createElement(Loader, null))) : /*#__PURE__*/React.createElement(Box, {
    width: {
      max: '1100px'
    },
    gap: "small",
    pad: "large",
    fill: "vertical",
    overflow: "auto"
  }, /*#__PURE__*/React.createElement(Box, {
    flex: false
  }, /*#__PURE__*/React.createElement(Box, {
    justify: "between",
    direction: "row",
    pad: {
      horizontal: 'medium',
      bottom: 'large'
    }
  }, /*#__PURE__*/React.createElement("u", null, /*#__PURE__*/React.createElement(Text, {
    weight: "bolder",
    size: "22px"
  }, "Steps to embed this dashboard")), /*#__PURE__*/React.createElement(Box, {
    onClick: () => closeLayer(),
    pad: {
      top: 'xsmall'
    }
  }, /*#__PURE__*/React.createElement(Close, {
    size: "20px"
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    justify: "between",
    pad: {
      horizontal: 'xlarge',
      bottom: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    width: "45%",
    gap: "small"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    weight: "bold"
  }, "Organisation ID"), /*#__PURE__*/React.createElement(Box, {
    pad: "medium",
    background: "black",
    round: "xsmall",
    direction: "row",
    align: "center",
    justify: "between"
  }, /*#__PURE__*/React.createElement(Box, {
    overflow: {
      horizontal: 'scroll'
    },
    pad: {
      top: 'small'
    }
  }, /*#__PURE__*/React.createElement(Text, null, payload.orgId)), /*#__PURE__*/React.createElement(Box, {
    alignSelf: "end"
  }, /*#__PURE__*/React.createElement(Copy, {
    value: payload.orgId
  })))), /*#__PURE__*/React.createElement(Box, {
    width: "45%",
    gap: "small"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    weight: "bold"
  }, "User Hash"), /*#__PURE__*/React.createElement(Box, {
    pad: "medium",
    background: "black",
    round: "xsmall",
    direction: "row",
    align: "center",
    justify: "between"
  }, /*#__PURE__*/React.createElement(Box, {
    overflow: {
      horizontal: 'scroll'
    },
    pad: {
      bottom: 'small'
    }
  }, /*#__PURE__*/React.createElement(Text, null, payload.userHash)), /*#__PURE__*/React.createElement(Box, {
    alignSelf: "end"
  }, /*#__PURE__*/React.createElement(Copy, {
    value: payload.userHash
  }))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    pad: {
      top: 'medium',
      bottom: 'large',
      horizontal: 'large'
    },
    flex: "false"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    margin: {
      bottom: 'large'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "20px"
  }, "STEP 1: Passing user Information"), /*#__PURE__*/React.createElement(Text, {
    size: "large"
  }, "You will need user information like the email, organization id and user-hash as a mandatory element in the API request body to generate the Authorization key."), /*#__PURE__*/React.createElement(Text, {
    size: "large"
  }, "Post your API request call by passing the above user information on any API testing application.")), /*#__PURE__*/React.createElement(Box, {
    margin: {
      bottom: 'large'
    },
    gap: "medium"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    pad: {
      horizontal: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Request body"), /*#__PURE__*/React.createElement(Box, {
    background: "black",
    pad: {
      horizontal: 'medium'
    },
    round: "xsmall",
    direction: "row",
    align: "center",
    justify: "between"
  }, /*#__PURE__*/React.createElement(Box, {
    overflow: {
      horizontal: 'scroll'
    }
  }, /*#__PURE__*/React.createElement("pre", {
    style: {
      whiteSpace: 'pre-wrap',
      wordBreak: 'keep-all'
    }
  }, /*#__PURE__*/React.createElement("code", null, /*#__PURE__*/React.createElement(Text, null, JSON.stringify(payload, null, 4))))), /*#__PURE__*/React.createElement(Box, {
    alignSelf: "end",
    margin: {
      bottom: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Copy, {
    value: JSON.stringify(payload, null, 4)
  })))), /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    pad: {
      horizontal: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Request URL"), /*#__PURE__*/React.createElement(Box, {
    pad: "medium",
    background: "black",
    round: "xsmall",
    direction: "row",
    align: "center",
    justify: "between"
  }, /*#__PURE__*/React.createElement(Box, {
    overflow: {
      horizontal: 'scroll'
    }
  }, /*#__PURE__*/React.createElement(Text, null, `${APIbaseUrl}validate-user/`)), /*#__PURE__*/React.createElement(Box, {
    alignSelf: "end"
  }, /*#__PURE__*/React.createElement(Copy, {
    value: `${APIbaseUrl}validate-user/`
  }))))), /*#__PURE__*/React.createElement(Box, {
    margin: {
      bottom: 'small'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "18px",
    weight: "bold"
  }, "Code Sample for user-hash generation.")), /*#__PURE__*/React.createElement(Box, {
    margin: {
      bottom: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large"
  }, "Developer should develop the code in server side language for generating the user-hash and passing it through.")), /*#__PURE__*/React.createElement(Accord, {
    active: active,
    setActive: setActive,
    index: 1,
    title: "Using JavaScript",
    margin: {
      bottom: 'large'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "samll"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large"
  }, "The example uses \"sha512crypt-node\" package to generate the user-hash.")), /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    pad: {
      horizontal: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Code Snippet"), /*#__PURE__*/React.createElement(Box, {
    background: "black",
    pad: {
      horizontal: 'medium'
    },
    round: "xsmall",
    direction: "row",
    align: "center",
    justify: "between"
  }, /*#__PURE__*/React.createElement(Box, {
    overflow: {
      horizontal: 'scroll'
    }
  }, /*#__PURE__*/React.createElement("pre", {
    style: {
      whiteSpace: 'pre-wrap',
      wordBreak: 'keep-all'
    }
  }, /*#__PURE__*/React.createElement("code", null, /*#__PURE__*/React.createElement(Text, null, hashScript)))), /*#__PURE__*/React.createElement(Box, {
    alignSelf: "end",
    margin: {
      bottom: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Copy, {
    value: hashScript
  }))))), /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    margin: {
      bottom: 'large'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "20px"
  }, "STEP 2: Use the script to embed the page."), /*#__PURE__*/React.createElement(Text, {
    size: "large"
  }, "After completing Step 1 above, the API request will return the Authorization Token and organization ID in the response."), /*#__PURE__*/React.createElement(Text, {
    size: "large"
  }, `Copy and paste the below script with Authorization Token and organization ID, in the body of the webpage you want to
                    embed on, to display the contents of this dashboard from ${projectName}.`)), /*#__PURE__*/React.createElement(Accord, {
    active: active,
    setActive: setActive,
    index: 2,
    title: "Embed using code snippet",
    margin: {
      bottom: 'large'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "xsmall"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large"
  }, "Add the following code snippet just before the body of the webpage."), /*#__PURE__*/React.createElement(Text, {
    size: "large"
  }, "Or, copy the code and send it to your developer to embed it for you.")), /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    pad: {
      horizontal: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, "Code Snippet"), /*#__PURE__*/React.createElement(Box, {
    background: "black",
    pad: "medium",
    round: "xsmall",
    direction: "row",
    align: "center",
    justify: "between"
  }, /*#__PURE__*/React.createElement(Box, {
    overflow: {
      horizontal: 'scroll'
    }
  }, /*#__PURE__*/React.createElement("pre", null, /*#__PURE__*/React.createElement("code", null, /*#__PURE__*/React.createElement(Text, null, url)))), /*#__PURE__*/React.createElement(Box, {
    alignSelf: "end",
    margin: {
      bottom: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Copy, {
    value: url
  })))))))));
};
ViewUrlLayer.propTypes = {
  layer: PropTypes.string,
  closeLayer: PropTypes.func
};
export default ViewUrlLayer;